module.exports = __webpack_public_path__ + "static/Number 100-f29fada4205144d1809b1df5d11addfc.jpg";